// const url = "http://localhost:8000/api";
// const url = "http://da-test:3071/api";
const url = "//erm.forensic-da.com/api";
const endpoints = {
    risks: url + '/risks',
    allAlerts: url + "/alerts/list_all/",
    alerts: url + "/alerts",
    alert: url + "/alerts/",
    tasksTab: url + "/tasks/",
    tasks: (alertId) =>{
        return url + "/alerts/"+ alertId + "/tasks/";
    },
    task: url + "/tasks/",
    tasksSub: (taskktId) => {
        return url +  "/tasks/" + taskktId + "/" + "respond/";
    },
    log: (alertId) => {
        return "/alerts/"+ alertId + "/logs";
    },
    transaction: url + "/transactions",
    transactionPagination: (serverPage) => {
        return url + "/transactions" + "?page="+serverPage
    },
    entities: (type) =>{
        return url + "/entities?type=" + type;
    },
    entity:(entityID) => {
        return url + "/entities/" + entityID;
    },
    entity_transaction: (entityId) => {
        return "/entities/"+entityId+"/transactions";
    },
    auth: url + "/auth",
    menu: url + "/menus",
    attachment: url + "/upload",
    rrattachment: url + "/rrupload",
    rrattachmentdownload: url + "/rrdownload/",
    assigneeList: url + "/users/list_of_assignee/",
    kri: url + "/krimonitoring/",
    risk: url + "/risks/",
    AP: url + "/action_plans/",
    controls: url + "/controls/",
    employees: url + "/employees/",
    owners: url + "/owners/",
    KriThresholds: url + '/kriThresholds/',
    risktolerances: url + '/risktolerances/',
    rainfalldata: url + '/krirainfall/'

};

export default endpoints;



// WEBPACK FOOTER //
// ./src/config/config.js